import React, {Component} from "react";
import {Button, Popconfirm} from "antd";
import BaseComponent from "../../../../../base/BaseComponent";
import {message} from "../../../utils/sysManagementUtils";

export default class DeptTableOperation extends BaseComponent {
    render() {
        const {data, data: {name, id}} = this.props;
        return (
            <div style={{display: "flex"}}>

                <span onClick={() => this.props.showEditModal(data, "")} className="cm-link"
                      style={{marginRight: 15}}>修改</span>

                <span onClick={() => this.props.showEditModal(null, id)} className="cm-link"
                      style={{marginRight: 15}}>添加子部门</span>

                <Popconfirm
                    title={`确定删除部门：${name}`}
                    onConfirm={() => this.deleteDept(id)}
                    okText="确定"
                    cancelText="取消"
                >
                    <span className="cm-link">
                        <span>删除</span>
                    </span>
                </Popconfirm>
            </div>
        );
    }


    deleteDept = id => {
        this.delDeptByIdRequest(id, res => {
            message.success("部门删除成功");
            this.props.updateData();
        });
    };


    /**
     * 获取部门树
     * @param id
     * @param callBack
     */
    delDeptByIdRequest = (id, callBack) => {
        this.request({
            url: "/cm-sites-sys/dept/statusOperation",
            body: {id, operation: "delete"},
            callBack
        });
    };


}

